define('SageDotCom/Components/Content/ProductTour/ProductTourSection',["jquery"],
    function ($) {
        
        function ProductTourSection(scope) {
            function init() {
                var $sectionEl = $(scope).find(".product-tour-section");
                var sectionEl = $sectionEl.get(0);

                $(sectionEl).find(".pt-intro").find("video").removeAttr("controls");

                $(window).on("scroll resize",
                    function () {

                        $sectionEl.find('.fade-in').each(function (i, el) {
                            var $el = $(el);

                            if ($el.offset().top < window.pageYOffset + window.innerHeight) {
                                $el.addClass('visible');
                            }
                        });

                        var windowOffset = window.innerHeight * .4;
                        var offset = sectionEl.offsetTop - window.pageYOffset;

                        if (offset + sectionEl.offsetHeight < windowOffset) {
                            $sectionEl.removeClass('is-current').addClass('is-complete');
                            $sectionEl.find('video').each(function(i, el) {
                                el.pause();
                            });
                        } else if (offset < windowOffset) {
                            $sectionEl.removeClass('is-complete').addClass('is-current');
                        } else {
                            $sectionEl.removeClass('is-current is-complete');
                            $sectionEl.find('video').each(function(i, el) {
                                el.pause();
                            });
                        }

                        if ($sectionEl.hasClass("intro")) {
                            $sectionEl.find('.pt-large-text').on('animationend',
                                function(e) {
                                    $sectionEl.addClass('offset');
                                });
                        }

                        var $scrollCta = $sectionEl.find(".scroll-cta");
                        if ($scrollCta.length > 0) {
                            $scrollCta.off("click").on("click", function () {
                                var target = this.getAttribute('data-target'),
                                    offset = $(".product-tour-section").filter('.' + target).offset().top;

                                    $('html, body').animate({ scrollTop: offset });

                            });
                        }

                        $sectionEl.find("video").on("play pause ended", function (e) {
                            var $trigger = $('.' + e.target.getAttribute('data-trigger'));

                            switch (e.type) {
                            case 'play':
                                $trigger.addClass('is-playing');
                                break;
                            case 'pause':
                                $trigger.removeClass('is-playing');
                                break;
                            case 'ended':
                                $trigger.removeClass('is-playing');
                                break;
                            default:
                                return false;
                            }
                            return false;
                        });

                    });


                var playVideo = function(video) {
                    var promise = video.play();

                    if (promise !== null && promise !== undefined) {
                        promise.then(function() {
                                video.muted = false;
                            },
                            function(reason) {
                                video.muted = true;
                                video.play();
                            });
                    }
                }


                $sectionEl.find('.play').on("click", function (e) {
                    var targetVideos = $(e.target).data('targets');
                    var targetVideoWrapper = $('.' + targetVideos[0]).is(':visible')
                        ? $('.' + targetVideos[0])
                        : $('.' + targetVideos[1]);
                    var targetVideo = targetVideoWrapper.find("video").get(0);

                    if (targetVideo) {
                        var isVideoPlaying = function(video) {
                            return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
                        };

                        isVideoPlaying(targetVideo) ? targetVideo.pause() : playVideo(targetVideo);
                    }
                });
            }

            init();
        };

        return function initProductTourSection(args) {
            return args.IsExperienceEditorEditing === false ?
                new ProductTourSection(args.scope) : null;
        };
    });
